import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen w-full bg-[#FAFAF7] text-[#3D3D3D] font-sans selection:bg-[#1B6B3A] selection:text-white" data-id="element-296">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-20 lg:py-28" data-id="element-297">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1B6B3A] hover:text-[#165930] transition-colors mb-10 lg:mb-14 text-sm lg:text-base font-medium" data-id="element-298">
          <ArrowLeft className="w-4 h-4" data-id="element-299" />
          Back to Closing Number Lock
        </Link>

        <h1 className="text-3xl lg:text-5xl font-serif font-bold text-[#1A1A1A] mb-4 lg:mb-6" data-id="element-300">
          Terms of Service
        </h1>
        <p className="text-sm lg:text-base text-[#6B6B6B] mb-12 lg:mb-16" data-id="element-301">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-10 lg:space-y-14 text-base lg:text-lg leading-relaxed lg:leading-loose" data-id="element-302">
          <section data-id="element-303">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-304">
              1. Overview
            </h2>
            <p data-id="element-305">
              These Terms of Service ("Terms") govern your purchase and use of
              the Closing Number Lock digital checklist product ("Product"). By
              purchasing or using the Product, you agree to be bound by these
              Terms.
            </p>
          </section>

          <section data-id="element-306">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-307">
              2. Product Description
            </h2>
            <p className="mb-4" data-id="element-308">
              Closing Number Lock is a digital information product that includes
              checklists, scripts, and planning tools designed to help
              homebuyers coordinate their closing process. The Product includes:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-309">
              <li data-id="element-310">The 7‑3‑1 Confirmation Calendar</li>
              <li data-id="element-311">Day‑7, Day‑3, and 24-hour checklists</li>
              <li data-id="element-312">Moving Lines Tracker</li>
              <li data-id="element-313">Copy-paste communication scripts</li>
              <li data-id="element-314">Plan B options guide</li>
            </ul>
          </section>

          <section data-id="element-315">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-316">
              3. Important Disclaimers
            </h2>
            <p className="mb-4" data-id="element-317">
              The Product is provided for{' '}
              <strong data-id="element-318">informational and educational purposes only</strong>. It
              does not constitute:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-319">
              <li data-id="element-320">
                <strong data-id="element-321">Legal advice</strong> — Consult a licensed attorney for
                legal questions.
              </li>
              <li data-id="element-322">
                <strong data-id="element-323">Financial advice</strong> — Consult a licensed financial
                advisor for financial decisions.
              </li>
              <li data-id="element-324">
                <strong data-id="element-325">A guarantee</strong> — We do not guarantee that your
                closing numbers will not change. The Product is a coordination
                tool to help you identify changes earlier.
              </li>
            </ul>
          </section>

          <section data-id="element-326">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-327">
              4. Purchase & Delivery
            </h2>
            <p data-id="element-328">
              The Product is a one-time digital purchase. Upon successful
              payment, you will receive immediate access to download the
              Product. All sales are final. Due to the digital nature of the
              Product, refunds are not provided once the Product has been
              delivered and accessed.
            </p>
          </section>

          <section data-id="element-329">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-330">
              5. Permitted Use
            </h2>
            <p className="mb-4" data-id="element-331">
              Your purchase grants you a personal, non-transferable license to
              use the Product for your own home closing process. You may not:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-332">
              <li data-id="element-333">Redistribute, resell, or share the Product with others</li>
              <li data-id="element-334">
                Use the Product for commercial purposes or to create derivative
                products
              </li>
              <li data-id="element-335">Claim authorship of the Product or its contents</li>
            </ul>
          </section>

          <section data-id="element-336">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-337">
              6. Limitation of Liability
            </h2>
            <p data-id="element-338">
              To the maximum extent permitted by law, Closing Number Lock and
              its creators shall not be liable for any direct, indirect,
              incidental, or consequential damages arising from the use or
              inability to use the Product. The Product is provided "as is"
              without warranties of any kind.
            </p>
          </section>

          <section data-id="element-339">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-340">
              7. Changes to Terms
            </h2>
            <p data-id="element-341">
              We reserve the right to update these Terms at any time. Changes
              will be posted on this page with an updated revision date.
              Continued use of the Product after changes constitutes acceptance
              of the revised Terms.
            </p>
          </section>

          <section data-id="element-342">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-343">
              8. Contact
            </h2>
            <p data-id="element-344">
              If you have questions about these Terms, please contact us at{' '}
              <span className="text-[#1B6B3A] font-medium" data-id="element-345">
                support@closingnumberlock.com
              </span>
              .
            </p>
          </section>
        </div>

        <footer className="mt-24 lg:mt-32 pt-12 border-t border-[#1B6B3A]/20 pb-12" data-id="element-346">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#6B6B6B]" data-id="element-347">
            <p data-id="element-348">
              © {new Date().getFullYear()} Closing Number Lock. All rights
              reserved.
            </p>
            <div className="flex items-center gap-6" data-id="element-349">
              <span className="text-[#1A1A1A] font-medium" data-id="element-350">
                Terms of Service
              </span>
              <Link to="/privacy" className="hover:text-[#1B6B3A] transition-colors duration-200 underline underline-offset-2 decoration-[#6B6B6B]/30 hover:decoration-[#1B6B3A]" data-id="element-351">
                Privacy Policy
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}